import React, { useEffect, useState } from 'react';
import logo from '../img/ems.png';
import { Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import UserInfo from '../components/UserInfo';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Online from '../components/Online';

const Alert = withReactContent(Swal);

function logout() {
    localStorage.clear();
    window.location.reload();
}


const Home = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        const stored = localStorage.getItem('ems_member');
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Date.now() < parsed.expiresAt) {
                setUser(parsed.user);
            } else {
                localStorage.removeItem('ems_member');
            }
        }

        if (code && !stored) {
            fetch(`https://ems.lexikonn.eu/api/dc.php?code=${code}`)
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        Alert.fire({
                            icon: 'error',
                            title: 'Přihlášení selhalo',
                            text: data.error,
                        });
                    } else {
                        const payload = {
                            user: data,
                            expiresAt: Date.now() + 1000 * 60 * 60 * 72,
                        };
                        localStorage.setItem('ems_member', JSON.stringify(payload));
                        window.location.href = '/';
                    }
                })
                .catch(() => {
                    Alert.fire({
                        icon: 'error',
                        title: 'Chyba',
                        text: 'Nepodařilo se ověřit přihlášení.',
                    });
                });
        }
    }, []);

    return (
        <div className="container my-5 p-5 text-center">
            <img src={logo} alt="EMS Logo" className="home-logo" /><br/>
            {!user ? (
                <a
                    href="https://discord.com/oauth2/authorize?client_id=1357814171848278247&response_type=code&redirect_uri=https%3A%2F%2Fems.lexikonn.eu&scope=identify+guilds.members.read"
                    className="discord-login"
                >
                    <i class="bi bi-discord"></i> Přihlásit se
                </a>
            ) : (
                <>
                    {user && (
                        <UserInfo user={user} />
                    )}
                    <Row className="justify-content-center">
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/zapis")} variant="danger">
                                <i className="bi bi-pencil-square"></i> Zápis
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/archiv")} variant="danger">
                                <i className="bi bi-table"></i> Záznamy
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/materialy")} variant="danger">
                                <i className="bi bi-archive-fill"></i> Materiály
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/statistiky")} variant="danger">
                                <i className="bi bi-graph-up"></i> Statistiky
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/pacient")} variant="danger">
                                <i className="bi bi-clipboard2-pulse-fill"></i> Karta pacienta
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/zamestnanec")} variant="danger">
                                <i className="bi bi-person-rolodex"></i> Karta záchranáře
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={() => navigate("/oceneni")} variant="danger">
                                <i className="bi bi-award-fill"></i> Vyznamenaní záchranáři
                            </Button>
                        </Col>
                        <Col className="my-2" xs={12} md={4}>
                            <Button className="w-100" size="lg" onClick={logout} variant="danger">
                                <i className="bi bi-box-arrow-right"></i> Odhlásit
                            </Button>
                        </Col>
                    </Row>
                    <div className="my-3">
                        <Online/>
                    </div>
                </>
            )}
        </div>
    );
};

export default Home;
